export const CONTACT_PATH = "/contact";
